<template>
  <v-edit-dialog
    ref="editDialog"
    @open="open"
    @save="save"
  >
    {{ value || '-' }}
    <template v-slot:input>
      <v-row class="align-center">
        <v-col md="5" class="pt-0">
          <v-menu
            ref="menuDate"
            v-model="datePickerState"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="changeDate"
                label="Дата события"
                persistent-hint
                prepend-icon="event"
                readonly
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="changeDate"
              locale="ru"
              no-title
              :first-day-of-week="1"
              @input="datePickerState = false"
            />
          </v-menu>
        </v-col>
        <v-col md="4" class="pt-0">
          <v-menu
            ref="menu"
            v-model="timePickerState"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="changeTime"
                label="Время события"
                prepend-icon="access_time"
                readonly
                v-on="on"
              />
            </template>
            <v-time-picker
              v-if="timePickerState"
              v-model="changeTime"
              format="24hr"
              full-width
              @click:minute="timePickerState = false"
            />
          </v-menu>
        </v-col>
        <v-col md="3" class="pt-0">
          <v-btn
            class="primary"
            @click="save"
          >
            Сохранить
          </v-btn>
        </v-col>
      </v-row>
    </template>
  </v-edit-dialog>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    happenedAt: {
      type: Object,
    },
  },
  data: () => ({
    value: null,
    date: null,
    time: null,
    changeDate: null,
    changeTime: null,
    datePickerState: false,
    timePickerState: false,
  }),
  created() {
    if (this.happenedAt) {
      const m = moment(this.happenedAt.date);
      this.date = m.format('YYYY-MM-DD');
      this.time = m.format('HH:mm');
      this.value = m.format('DD.MM.YYYY HH:mm');
    }
  },
  methods: {
    open() {
      this.changeDate = this.date;
      this.changeTime = this.time;
    },
    save() {
      this.date = this.changeDate;
      this.time = this.changeTime;
      if (this.date && this.time) {
        const m = moment(`${this.date} ${this.time}`);
        this.value = m.format('DD.MM.YYYY HH:mm');
        this.$emit('update', m.format('YYYY-MM-DD HH:mm:ss'));
      } else {
        this.value = null;
        this.$emit('update', null);
      }
      this.$refs.editDialog.save();
    },
  },
};
</script>

<style>
</style>
